import {
   MedicalInformationApproveDraftCommand,
   MedicalInformationType,
} from '@dreryk/egabinet-patient-medical-information-frontend-api';
import { ConfidentialityLevel } from '@dreryk/egabinet-medical-data-confidentiality-published-language-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarNegativeEvent, dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { ExternalDocumentationStorageLimitExceededTranslation } from '../../common/ExternalDocumentationStorageLimitExceededTranslation';
import { patientMedicalInformationTranslationKeys } from '../../translations';

/**
 * TODO: DREGAB-5421 Add missing Fault
 */
type ExternalDocumentationStorageLimitExceededFault = {
   class: 'eGabinetHealthcareProvider:ExternalDocumentationStorageLimitExceededFault';
};

export type MedicalInformationApproveDraftSubmitValues = {
   description: string | null;
   confidentialityLevel: ConfidentialityLevel;
};

type UseMedicalInformationApproveDraftCommandOptions = {
   medicalInformationId: number;
   medicalInformationType: MedicalInformationType;
   onSuccess: (parameters: MedicalInformationApproveDraftSubmitValues) => void;
};

export const useMedicalInformationApproveDraftCommand = (
   options: UseMedicalInformationApproveDraftCommandOptions
): UseCqrsCommandResult<void, MedicalInformationApproveDraftSubmitValues> => {
   return useCqrsCommand<
      void,
      MedicalInformationApproveDraftSubmitValues,
      ExternalDocumentationStorageLimitExceededFault
   >(
      (parameters) => {
         const command = new MedicalInformationApproveDraftCommand();
         command.id = options.medicalInformationId;
         command.type = options.medicalInformationType;
         command.description = parameters.description!;
         command.confidentialityLevel = parameters.confidentialityLevel;
         return command;
      },
      {
         onSuccess: (__, parameters) => {
            dispatchSnackbarPositiveEvent(patientMedicalInformationTranslationKeys.successfullyAddedNewEntry);
            options.onSuccess(parameters);
         },
         onFault: {
            'eGabinetHealthcareProvider:ExternalDocumentationStorageLimitExceededFault': () =>
               dispatchSnackbarNegativeEvent(<ExternalDocumentationStorageLimitExceededTranslation />),
         },
      }
   );
};
